import React from 'react';
import styles from '../../Styles/Reservations.module.css';
import { displayDay, canCancelReservation } from '../../Utils/ReservationsUtil';

function ReservationPopup({
  popupRef,
  selectedSlot,
  activeCalendarId,
  getSlotConfig,
  cancelLimitHours,
  popError,
  user,
  weeklyLimitReached,
  maxPerWeekLimit,
  onCancelBooking,
  onConfirmBooking,
}) {
  if (!selectedSlot) return null;

  const price =
    getSlotConfig(
      activeCalendarId,
      selectedSlot.date,
      selectedSlot.hour
    )?.price || 0;

  const isExisting = !!selectedSlot.existing;
  const isMine = selectedSlot.existing?.id === user?.uid;

  return (
    <div ref={popupRef} className={styles.bookingpopup}>
      <p>
        Ajankohta: {displayDay(selectedSlot.date)}, klo {selectedSlot.hour}:00
      </p>
      <p>Hinta: {price} €</p>
      {!isExisting && cancelLimitHours > 0 && (
        <p style={{ color: '#bbb', marginTop: 6 }}>
          Peruutus mahdollista max {cancelLimitHours}h ennen varausta
        </p>
      )}
      {popError && <p style={{ color: '#d33', marginTop: 8 }}>{popError}</p>}
      {isExisting ? (
        isMine ? (
          (() => {
            const allowed = canCancelReservation({
              date: selectedSlot.date,
              hour: selectedSlot.hour,
              cancelLimitHours,
            });
            if (!allowed) {
              return (
                <p style={{ color: '#bbb', marginTop: 10 }}>
                  Varauksen peruutus mahdollista korkeintaan {cancelLimitHours} h <br />
                  ennen varauksen alkua.
                </p>
              );
            }
            return (
              <button className={styles.primaryBtn} onClick={onCancelBooking}>
                Peru varaus
              </button>
            );
          })()
        ) : null
      ) : weeklyLimitReached ? (
        <p style={{ color: '#bbb', marginTop: 10 }}>
          Varauksia ei voi tehdä enemmän kuin {maxPerWeekLimit} kpl per vko.
        </p>
      ) : (
        <button className={styles.primaryBtn} onClick={onConfirmBooking}>
          Vahvista varaus
        </button>
      )}
    </div>
  );
}

export default ReservationPopup;